@if (options?.length) {
  <ng-form #form="ngForm"
    class="block p-b-2 p-b-3-s">
    <p class="s2 p-b-3">{{'Size' | translate}}:</p>
    <input-wrap class="block">
    <select class="input"
      name="crosssell_product"
      [(ngModel)]="id"
      [muiInput]="'Choose From % Sizes' | translate: options.length">
      @for (option of options; track trackByProductId($index, option)) {
        <option
          [value]="option.id">
          {{option.data.config_size | optionLabel: 'config_size'}}
        </option>
      }
    </select>
  </input-wrap>
</ng-form>
}